import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

/*
 * The shop's current payout account — the most recent active `payout_cut` row,
 * joined to the user it pays. Admin-only, and null for a shop with no split,
 * which is precisely what the `shop_split` setup check reports on.
 */
export default function useShopSplit(influencerId) {
  const { data, mutate, error } = useSWR(
    influencerId ? `/api/payoutCut/${influencerId}` : null,
    fetcher,
  );

  const shopSplit = React.useMemo(() => data?.payoutCut ?? null, [data]);

  return {
    isError: error,
    isLoading: !error && !data,
    mutate,
    shopSplit,
  };
}
